import { useState } from 'react';
import { isEmpty } from '../../../../utils/UtilityFunctions';
import cx from 'classnames'
import classes from "./TextPhoneNumber.module.css";
import globalClasses from '../../../../App.module.css';
import PhoneInput from 'react-phone-input-2';
import "react-phone-input-2/lib/style.css";

let countryCode = localStorage.getItem("countryCode");

function PhoneField(props) {
    let {containerClass, value, onChangeHandler, isDisabled, isFieldError,
        label, id, isError, validate, isMandatory, mobileData, mobileNormal } = props;

    let labelComponent = null

    let [isPhoneError,setIsPhoneError]=useState(false);
    let [errorPhone,setErrorPhone] = useState("");
    
    const validatePhoneField = (value,data,formattedValue) => {
        let validateResult = validate(value,data,formattedValue, isMandatory)
        setIsPhoneError(validateResult.error)
        setErrorPhone(validateResult.text)
    }

    const onChangePhone = (value, data, event, formattedValue) => {
        onChangeHandler(value,data,formattedValue)
        if(isError){
            validatePhoneField(value,data,formattedValue)
        }
    }

    if(isFieldError && !isPhoneError){
        validatePhoneField(mobileNormal,mobileData, value)
    }

    if (!isEmpty(countryCode)) {
        countryCode = countryCode.toLowerCase();
      } else {
        countryCode = "us";
      }

    if(!isEmpty(label)){
        labelComponent = (
            <label
                className={cx([globalClasses.FormLabel,isMandatory?globalClasses.FormRequiredInput: ''])} 
                htmlFor={id}>
                {label}
            </label>
        )
    }
    let formFieldContainerClass = isEmpty(containerClass)? "form-group col-12 col-md-6 px-1 px-md-3 my-3" 
                                    : containerClass;
    return(
        <div className={formFieldContainerClass}>
            {labelComponent}
            <PhoneInput
                value={value}
                placeholder={"Enter mobile number"}
                country={countryCode}
                // autoFormat={false}
                // disableCountryCode={true}
                preferredCountries={['in','us','au']}
                // enableSearch={true}
                // disableSearchIcon={true}
                // searchPlaceholder={'Search for country / country code'}
                // searchNotFound={'No result found'}
                // enableLongNumbers={true}
                // areaCodes={{'in' : ['4268','44']}}
                countryCodeEditable={true}
                // enableAreaCodeStretch
                // enableAreaCodes={true}
                inputClass={cx([classes.InputPhoneText, globalClasses.FormInput,
                    (isPhoneError)? globalClasses.ErrorFormInput : ''])}
                onChange={onChangePhone}
                disabled={isDisabled}
            />
            <span className={globalClasses.ErrorText}>
                {errorPhone}
            </span>
        </div>
    )
}

export default PhoneField;